export default __webpack_public_path__ + "static/media/not-qualified.f20def01.svg";